import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";
import { Fragment } from "react";
import { StudyLinks } from "@modules/study/country/study_why_country";
import { LayoutMain } from "@unisearch/theme/layout";

const StudyBannerTwo = dynamic(() =>
  import("@modules/study/country/study_banner_two")
);
const StudyBanner = dynamic(() =>
  import("@modules/study/country/study_banner")
);
const StudyVideo = dynamic(() => import("@modules/study/country/study_video"));
const StudyWhyCountryIntro = dynamic(() =>
  import("@modules/study/country/study_why_country/study_why_country_intro")
);
const ScrollPopup = dynamic(() => import("@unisearch/common/scroll_popup"), {
  ssr: false,
});

const Exam = ({ pageData, exam_name }) => {
  return (
    <Fragment>
      <LayoutMain
        isLeadPopup={true}
        footer_with_evaluation
        title={pageData?.pageTitle}
        metaTitle={pageData?.metaTitle || pageData?.pageTitle}
        metaKeywords={pageData?.metaKeyword || "unisearch, exam"}
        metaDescription={
          pageData?.metaDescription ||
          "Apply to Universities Abroad with expert guidance from existing students"
        }
        metaImage={pageData?.featureImage?.src}
        metaUrl={`${process.env.NEXT_PUBLIC_URL}/exam/${exam_name}`}
      >
        <>
          {pageData && pageData?.videoType ? (
            <StudyBannerTwo
              pageData={pageData}
              name={exam_name}
              linkType="exam"
            />
          ) : (
            <StudyBanner pageData={pageData} name={exam_name} linkType="exam" />
          )}
          {(pageData?.videoupload !== null || pageData?.embedCode !== "") && (
            <StudyVideo pageData={pageData} />
          )}
          <StudyLinks linkType="exam" name={exam_name} pageData={pageData} />
          <StudyWhyCountryIntro
            linkType="exam"
            name={exam_name}
            pageData={pageData}
          />
        </>
      </LayoutMain>
      {/* <ScrollPopup /> */}
    </Fragment>
  );
};

export default Exam;

export async function getServerSideProps({ params }) {
  const { exam_name } = params;

  let props = {
    pageData: {},
    exam_name: exam_name,
  };

  try {
    const pageDetail = await API.get(
      `/public/page?pageType=exam&slug=${exam_name}`
    );
    if (!pageDetail.error && pageDetail.data) {
      props.pageData = pageDetail.data;
    } else {
      return {
        notFound: true,
      };
    }

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
